import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';

type SetCaptchaTokenProps = {
  captchaToken: string;
};

/**
 * Sets the given captcha token in the client state.
 *
 * @param params.captchaToken - The captcha token to set.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const setCaptchaToken = (
  { captchaToken }: SetCaptchaTokenProps,
  client = getDefaultClient()
) => {
  const core = getCore(client);

  core.state.set({
    captchaToken,
  });
};
